var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { staticClass: "cardList" },
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _vm.responsavel.nome
                ? _c("app-display", {
                    class:
                      _vm.compararResumoGeo &&
                      _vm.compararResumoGeo.mudouNomeResponsavel
                        ? "text"
                        : "",
                    attrs: {
                      label: "Responsável:",
                      content: _vm.responsavel.nome
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _vm.responsavel.cpf
                ? _c("app-display", {
                    class:
                      _vm.compararResumoGeo &&
                      _vm.compararResumoGeo.mudouCpfResponsavel
                        ? "text"
                        : "",
                    attrs: {
                      label: "CPF do responsável:",
                      content: _vm.responsavel.cpf
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _vm.responsavel.creaRnp
                ? _c("app-display", {
                    class:
                      _vm.compararResumoGeo &&
                      _vm.compararResumoGeo.mudouCreaRnp
                        ? "text"
                        : "",
                    attrs: { label: "RNP:", content: _vm.responsavel.creaRnp }
                  })
                : _vm._e()
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _vm.responsavel.formacao
                ? _c("app-display", {
                    class:
                      _vm.compararResumoGeo &&
                      _vm.compararResumoGeo.mudouFormacao
                        ? "text"
                        : "",
                    attrs: {
                      label: "Formação:",
                      content: _vm.responsavel.formacao
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _vm.responsavel.codigoIncra
                ? _c("app-display", {
                    class:
                      _vm.compararResumoGeo &&
                      _vm.compararResumoGeo.mudouCodigoIncra
                        ? "text"
                        : "",
                    attrs: {
                      label: "Código de credenciamento junto ao INCRA:",
                      content: _vm.responsavel.codigoIncra
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              (_vm.possuiCredenciadoGeo != null &&
                _vm.possuiCredenciadoGeo != "") ||
              _vm.isPara
                ? _c("app-display", {
                    attrs: {
                      label: "Credenciado:",
                      content: _vm.possuiCredenciadoGeo ? "Sim" : "Não"
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-26955882", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26955882","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/informacoesCadastro/InformacoesResponsavelGeo.vue
// module id = null
// module chunks = 